import { useQuery } from "@tanstack/react-query";

import { appQueryKeys } from "@/app/data/appQueryKeys";
import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import type { DebugProblemsQueryType } from "@reflag/shared/eventAPI";

export function useDebugProblemsData(
  params: Omit<DebugProblemsQueryType, "envId"> = {},
) {
  const { appId, envId } = useEnvironment();
  const queryParams = { envId, ...params };

  return useQuery({
    queryKey: appQueryKeys.debugProblems(appId, envId, params),
    queryFn: async () => {
      const response = await api.get<"/apps/:appId/debug-events/problems">(
        `/apps/${appId}/debug-events/problems`,
        { params: queryParams },
      );
      return response.data.problems;
    },
  });
}
